import { useEffect, useState } from 'react';
import { Alert, Box, Button, MenuItem, Select, Typography } from '@mui/material';
import { fetchClientesComercial, useComercialContext } from './ComercialContext';
import { isSuccess } from '../common/domain/RemoteData.model';

const ComercialBanner = () => {
    const { actingAsCliente, setActingAsCliente, clearActingAsCliente } = useComercialContext();
    const [clientes, setClientes] = useState([]);
    const [selected, setSelected] = useState('');

    useEffect(() => {
        fetchClientesComercial().then(result => {
            if (isSuccess(result)) setClientes(result.value);
        });
    }, []);

    useEffect(() => {
        if (!actingAsCliente) setSelected('');
    }, [actingAsCliente]);

    const handleChange = (e) => {
        const numCliente = e.target.value;
        setSelected(numCliente);
        const cliente = clientes.find(c => c.numCliente === numCliente);
        if (cliente) setActingAsCliente(cliente);
    };

    return (
        <Alert severity="warning" sx={{ borderRadius: 0, alignItems: 'center' }} icon={false}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="body2" fontWeight="bold">
                    Modo comercial
                </Typography>
                {actingAsCliente ? (
                    <>
                        <Typography variant="body2">
                            Actuando como: <strong>{actingAsCliente.nombreRazonSocial}</strong> ({actingAsCliente.numCliente})
                        </Typography>
                        <Button size="small" variant="outlined" color="warning" onClick={() => { clearActingAsCliente(); setSelected(''); }}>
                            Cambiar cliente
                        </Button>
                    </>
                ) : (
                    <Select
                        variant="outlined"
                        size="small"
                        displayEmpty
                        value={selected}
                        onChange={handleChange}
                        sx={{ background: 'white', minWidth: 280 }}
                    >
                        <MenuItem value="" disabled>Selecciona un cliente...</MenuItem>
                        {clientes.map(c => (
                            <MenuItem key={c.numCliente} value={c.numCliente}>
                                {c.numCliente} — {c.nombreRazonSocial}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            </Box>
        </Alert>
    );
};

export default ComercialBanner;
